// extracted by mini-css-extract-plugin
module.exports = {"main":"ArrowKeyPad_main__2igmz"};